/**
 * @flow
 */

/* eslint-disable */

'use strict';

/*::
import type { ConcreteRequest } from 'relay-runtime';
export type FetchJiraServerOAuthUrlInput = {|
  jiraServerUrl?: ?string,
  clientId?: ?string,
  clientSecret?: ?string,
  csrfToken?: ?string,
  socketClientId?: ?string,
  clientMutationId?: ?string,
|};
export type fetchJiraServerOauthUrlMutationVariables = {|
  input: FetchJiraServerOAuthUrlInput
|};
export type fetchJiraServerOauthUrlMutationResponse = {|
  +fetchJiraServerOAuthUrl: ?{|
    +url: ?string,
    +token: ?string,
    +token_secret: ?string,
    +errors: ?string,
  |}
|};
export type fetchJiraServerOauthUrlMutation = {|
  variables: fetchJiraServerOauthUrlMutationVariables,
  response: fetchJiraServerOauthUrlMutationResponse,
|};
*/


/*
mutation fetchJiraServerOauthUrlMutation(
  $input: FetchJiraServerOAuthUrlInput!
) {
  fetchJiraServerOAuthUrl(input: $input) {
    url
    token
    token_secret
    errors
  }
}
*/

const node/*: ConcreteRequest*/ = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "input",
    "type": "FetchJiraServerOAuthUrlInput!"
  }
],
v1 = [
  {
    "alias": null,
    "args": [
      {
        "kind": "Variable",
        "name": "input",
        "variableName": "input"
      }
    ],
    "concreteType": "FetchJiraServerOAuthUrlPayload",
    "kind": "LinkedField",
    "name": "fetchJiraServerOAuthUrl",
    "plural": false,
    "selections": [
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "url",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "token",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "token_secret",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "errors",
        "storageKey": null
      }
    ],
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "fetchJiraServerOauthUrlMutation",
    "selections": (v1/*: any*/),
    "type": "Mutation"
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "fetchJiraServerOauthUrlMutation",
    "selections": (v1/*: any*/)
  },
  "params": {
    "id": null,
    "metadata": {},
    "name": "fetchJiraServerOauthUrlMutation",
    "operationKind": "mutation",
    "text": "mutation fetchJiraServerOauthUrlMutation(\n  $input: FetchJiraServerOAuthUrlInput!\n) {\n  fetchJiraServerOAuthUrl(input: $input) {\n    url\n    token\n    token_secret\n    errors\n  }\n}\n"
  }
};
})();
// prettier-ignore
(node/*: any*/).hash = '64d67d800f11a98e9ba92d32022c74fa';

module.exports = node;
